import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const ContentContext = createContext({ content: {}, loaded: false, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const r = await api.get("/content");
      const map = {};
      r.data.forEach((b) => {
        map[b.slot] = b.value;
      });
      setContent(map);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, loaded, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

/**
 * useContent(slot, fallback) — returns the CMS-edited value or the fallback if not loaded yet.
 * Use this everywhere instead of hardcoded strings.
 */
export function useContent(slot, fallback = "") {
  const { content } = useContext(ContentContext);
  const v = content[slot];
  return v !== undefined && v !== null && v !== "" ? v : fallback;
}

/** useContentRefresh — returns the refresh fn to re-fetch all CMS content. */
export function useContentRefresh() {
  return useContext(ContentContext).refresh;
}
